import React from "react";
import { Link } from "react-router-dom";

const copyByVariant = {
  admin: {
    eyebrow: "Admin Portal",
    title: "Halaman admin tidak ditemukan",
    body: "Route yang kamu akses tidak tersedia atau sudah dipindahkan.",
    primaryTo: "/admin/dashboard",
    primaryLabel: "Ke dashboard",
    secondaryTo: "/member/auth/login",
    secondaryLabel: "Ke portal user",
  },
  member: {
    eyebrow: "Portal Anggota",
    title: "Halaman user tidak ditemukan",
    body: "Menu atau halaman anggota yang kamu cari tidak tersedia.",
    primaryTo: "/member/home",
    primaryLabel: "Ke beranda",
    secondaryTo: "/member/profile",
    secondaryLabel: "Ke profil",
  },
  auth: {
    eyebrow: "PUGAR",
    title: "Halaman tidak ditemukan",
    body: "Alamat login atau halaman autentikasi yang kamu akses tidak tersedia.",
    primaryTo: "/member/auth/login",
    primaryLabel: "Login user",
  },
  global: {
    eyebrow: "PUGAR",
    title: "Halaman tidak ditemukan",
    body: "Route yang kamu akses tidak tersedia di aplikasi ini.",
    primaryTo: "/member/auth/login",
    primaryLabel: "Ke login user",
  },
};

export default function NotFoundPage({ variant = "global" }) {
  const copy = copyByVariant[variant] || copyByVariant.global;

  return (
    <div className={`not-found-page not-found-${variant}`}>
      <section className="not-found-card">
        <span>{copy.eyebrow}</span>
        <strong>404</strong>
        <h1>{copy.title}</h1>
        <p>{copy.body}</p>
        <div>
          <Link className="not-found-primary" to={copy.primaryTo}>
            {copy.primaryLabel}
          </Link>
          {copy.secondaryTo && copy.secondaryLabel && (
            <Link className="not-found-secondary" to={copy.secondaryTo}>
              {copy.secondaryLabel}
            </Link>
          )}
        </div>
      </section>
    </div>
  );
}
